// extracted by mini-css-extract-plugin
export default {"button":"EOPF_button__gLlIS"};